<script lang="ts">
	import { navigating, page } from '$app/stores';
	import ChevronDown from '$lib/assets/images/icons/chevron-down.svg?component';
	import { slide } from 'svelte/transition';
	import domain from '$lib/stores/DomainStore';
	import __ from '$lib/stores/TranslationStore';
	import { onMount } from 'svelte';
	import { twMerge } from 'tailwind-merge';

	interface Item {
		title: string;
		path: string;
	}

	export let title: string;
	export let items: Item[];
	export let titleClass: string = '';
	let showDropdown: boolean | any = false;
	$: showDropdown = itemsActive && $navigating;

	$: itemsActive = items.some((item) => basePath + item.path === $page.url.href);

	let basePath: string;

	onMount(() => {
		basePath = $page.data?.location?.origin;
	});
</script>

<li class="relative px-4 md:px-0 lg:min-w-0" on:keyup>
	<button
		class={twMerge(
			'header-link relative mt-6 flex w-full items-center justify-between pb-6 text-lg font-medium leading-7 md:mt-0 md:pb-0 md:text-sm xl:text-lg',
			titleClass
		)}
		class:active={items.some((item) => basePath + item.path === $page.url.href)}
		on:click={() => (showDropdown = !showDropdown)}
		on:keypress={() => (showDropdown = !showDropdown)}
		>{title}
		<ChevronDown class="w-5 duration-200 md:ml-2 md:w-4 {showDropdown ? 'rotate-180' : ''}" />
	</button>
	<!-- Dropdown menu -->
	{#if showDropdown}
		<div
			transition:slide
			class="translate left-0 top-8 z-10 font-light md:absolute md:mt-4 {$domain?.headerBackground} {$domain?.headerColor}"
		>
			<ul class="divide-light text-lg md:min-w-[65px] md:divide-y">
				{#each items as item}
					<li>
						<slot {item}>
							<a href={basePath + item.path} on:click class="block py-2 md:px-4">{item.title}</a>
						</slot>
					</li>
				{/each}
			</ul>
		</div>
	{/if}
</li>
